/** Whole-page loading state, used while the session probe settles. */
import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function FullPageSpinner() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg text-text-muted">
      {/* role=status so the wait is announced rather than being a silent blank page. */}
      <div role="status" className="flex items-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
        <span className="text-sm">{t('common.loading')}</span>
      </div>
    </div>
  )
}
